import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions, commonTextFilterParams } from '../../../lib/agGridOptions';
import { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR } from '../../../components/shared/agGridCells';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const FRAUD_GRID_DEFAULT_COL_DEF = {
  suppressAutoSize: true,
  filterParams: {
    ...commonTextFilterParams,
    filterOptions: ['contains'],
  },
};

export const fraudGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No payments have been screened in this period.</span>',
} satisfies GridOptions<any>;
